import { Button, Grid, TextField } from '@material-ui/core';
import React, { useCallback, useEffect, useState } from 'react';
import { isURL } from '../../../utils/url';
import { ReusableSelect as Select } from 'components/reusable/select';
import { setMessages } from 'store/actions/actions';
import { useGlobalState } from 'store/reducers/reducer';
import { adminCreateAccount, getAccountConfigDefaults, getAccounts } from 'store/sagas/sagas';
const validateFormBeforeSubmit = function validateFormBeforeSubmit(form, fnMessage) {
    const { url = '' } = form;
    // check if url value is a valid value
    if (url && !isURL(url)) {
        fnMessage(`the URL format is incorrect`);
        return false;
    }
    return true;
};
export const AccountCreateForm = () => {
    const { state, asyncDispatch, dispatch } = useGlobalState();
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [url, setUrl] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [setupAccountStep, setSetupAccountStep] = useState('');
    const [setupStatus, setSetupStatus] = useState('');
    const [city, setCity] = useState('');
    const [province, setProvince] = useState('');
    const [country, setCountry] = useState('');
    const [industry, setIndustry] = useState('');
    const [companySize, setCompanySize] = useState('');
    const [stripeCustomerId, setStripeCustomerId] = useState('');
    const [subscriptionId, setSubscriptionId] = useState('');
    const [subscriptionTier, setSubscriptionTier] = useState('');
    const [parentId, setParentId] = useState(undefined);
    const [parentAccounts, setParentAccounts] = useState(null);
    const [name, setName] = useState('');
    const [invalidData, setInvalidData] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    useEffect(() => {
        getAccounts(state.accessToken, {
            isDisabled: 'false',
            parents: 'true'
        }).then(({ accounts }) => {
            setParentAccounts(accounts);
        }, console.error);
    }, []);
    const submitAccount = async (data) => {
        setSubmitting(true);
        let configurationProperties;
        try {
            const props = await asyncDispatch(getAccountConfigDefaults());
            configurationProperties = { props };
        }
        catch (error) {
            // Defaults are best-effort; create without them if the fetch fails.
            console.error(error);
        }
        try {
            await asyncDispatch(adminCreateAccount(configurationProperties ? { ...data, configurationProperties } : data));
            dispatch(setMessages({
                value: `The account has been created`,
                severity: 'success'
            }));
        }
        catch (error) {
            console.error(error);
        }
        finally {
            setSubmitting(false);
        }
    };
    const createAccount = () => {
        const data = {
            firstName,
            lastName,
            name,
            url,
            email,
            phoneNumber,
            setupAccountStep,
            setupStatus,
            companySize,
            city,
            province,
            country,
            industry,
            stripeCustomerId,
            subscriptionId,
            subscriptionTier,
            parentId
        };
        const isValid = validateFormBeforeSubmit(data, (msg) => {
            dispatch(setMessages({
                value: msg,
                severity: 'warning'
            }));
        });
        if (!isValid)
            return;
        // overwrite url param
        if (!data.url) {
            data.url = 'https://www.vouched.id/';
        }
        void submitAccount(data);
    };
    const handleName = useCallback((e) => {
        setName(e.target.value);
        setInvalidData(false);
    }, []);
    const handleEmail = useCallback((e) => {
        setEmail(e.target.value);
        setInvalidData(false);
    }, []);
    const handleLastName = useCallback((e) => {
        setLastName(e.target.value);
        setInvalidData(false);
    }, []);
    const handleFirstName = useCallback((e) => {
        setFirstName(e.target.value);
        setInvalidData(false);
    }, []);
    const handleUrl = useCallback((e) => {
        setUrl(e.target.value);
        setInvalidData(false);
    }, []);
    const handlePhoneNumber = useCallback((e) => {
        setPhoneNumber(e.target.value);
        setInvalidData(false);
    }, []);
    const handleSetupAccountStep = useCallback((e) => {
        setSetupAccountStep(e.target.value);
        setInvalidData(false);
    }, []);
    const handleSetupStatus = useCallback((e) => {
        setSetupStatus(e.target.value);
        setInvalidData(false);
    }, []);
    const handleCountry = useCallback((e) => {
        setCountry(e.target.value);
        setInvalidData(false);
    }, []);
    const handleCity = useCallback((e) => {
        setCity(e.target.value);
        setInvalidData(false);
    }, []);
    const handleProvince = useCallback((e) => {
        setProvince(e.target.value);
        setInvalidData(false);
    }, []);
    const handleCompanySize = useCallback((e) => {
        setCompanySize(e.target.value);
        setInvalidData(false);
    }, []);
    const handleStripeCustomerId = useCallback((e) => {
        setStripeCustomerId(e.target.value);
        setInvalidData(false);
    }, []);
    const handleSubscriptionId = useCallback((e) => {
        setSubscriptionId(e.target.value);
        setInvalidData(false);
    }, []);
    const handleSubscriptionTier = useCallback((e) => {
        setSubscriptionTier(e.target.value);
        setInvalidData(false);
    }, []);
    const handleIndustry = useCallback((e) => {
        setIndustry(e.target.value);
        setInvalidData(false);
    }, []);
    const handleParentAccount = useCallback((e) => {
        setParentId(e.target.value);
        setInvalidData(false);
    }, []);
    return (React.createElement("div", null,
        React.createElement("h1", null, "Create Account"),
        React.createElement("div", { className: "filters-container" },
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { container: true, item: true, spacing: 3, xs: 12 },
                    React.createElement(Grid, { item: true, xs: 6 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Email", onChange: handleEmail, required: true, value: email }))),
                React.createElement(Grid, { container: true, item: true, spacing: 3, xs: 12 },
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "First name", onChange: handleFirstName, value: firstName })),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Last name", onChange: handleLastName, value: lastName })),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Name", onChange: handleName, required: true, value: name }))),
                React.createElement(Grid, { container: true, item: true, spacing: 3, xs: 12 },
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "URL", onChange: handleUrl, required: true, value: url })),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Phone Number", onChange: handlePhoneNumber, value: phoneNumber })),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Setup Account Step", onChange: handleSetupAccountStep, value: setupAccountStep }))),
                React.createElement(Grid, { container: true, item: true, spacing: 3, xs: 12 },
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Setup Status", onChange: handleSetupStatus, value: setupStatus })),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "City", onChange: handleCity, value: city })),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Country", onChange: handleCountry, value: country })),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Province", onChange: handleProvince, value: province }))),
                React.createElement(Grid, { container: true, item: true, spacing: 3, xs: 12 },
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Industry", onChange: handleIndustry, value: industry })),
                    React.createElement(Grid, { item: true, xs: 3 }),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Company Size", onChange: handleCompanySize, value: companySize }))),
                React.createElement(Grid, { container: true, item: true, spacing: 3, xs: 12 },
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Stripe Customer ID", onChange: handleStripeCustomerId, required: true, value: stripeCustomerId })),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Subscription ID", onChange: handleSubscriptionId, value: subscriptionId })),
                    React.createElement(Grid, { item: true, xs: 3 },
                        React.createElement(TextField, { className: "g-full-width u-margin-bottom-small", error: invalidData, label: "Subscription Tier", onChange: handleSubscriptionTier, value: subscriptionTier }))),
                React.createElement(Grid, { item: true, xs: 3 }, parentAccounts ? (React.createElement(Select, { className: "select-group", items: parentAccounts.map((a) => ({
                        id: a.id,
                        name: a.name
                    })), label: "Parent Account", name: "pageSize", onChange: handleParentAccount, value: parentId })) : null)),
            React.createElement(Button, { disabled: submitting, onClick: createAccount, style: {
                    marginTop: '15px',
                    ...(submitting
                        ? { backgroundColor: '#cccccc', color: '#666666' }
                        : {})
                } }, submitting ? 'Creating...' : 'Create'))));
};
